import React from "react";
import MarkdownDocPage from "@/components/MarkdownDocPage";
import { Award, Building2, ShieldCheck, UserCircle2 } from "lucide-react";

const STATS = [
  { icon: UserCircle2, label: "Accountable", value: "Founder & CEO" },
  { icon: Award, label: "Eagle Healthcare", value: "26 years" },
  { icon: ShieldCheck, label: "Accreditation", value: "Joint Commission" },
  { icon: Building2, label: "MCO contracts", value: "Alliance · Trillium · Partners · Vaya" },
];

export default function FounderCredibility() {
  return (
    <MarkdownDocPage
      title="Founder & Eagle Healthcare Credibility"
      subtitle="The submission-safe one-pager that turns 'brand-new company' into your strongest asset — lead the packet with it."
      mdUrl="/docs/GoMCO-Founder-Eagle-Credibility.md"
      pdfKey="founder-credibility"
      pdfName="GoMCO-Founder-Eagle-Credibility.pdf"
      stats={STATS}
      testid="founder-credibility-content"
    />
  );
}
